function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconPaintRexOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 28.002a1 1 0 01-.903-1.432c.138-.288.486-.908.903-1.631.417.723.765 1.343.903 1.63A1 1 0 0127 28.002zm2.706-2.297C29.222 24.697 27 21.002 27 21.002s-2.222 3.695-2.706 4.703a3 3 0 105.412 0zM14.65 25.441a1.96 1.96 0 01-1.396.578 1.957 1.957 0 01-1.394-.578l-6.282-6.28A1.96 1.96 0 015 17.763c0-.526.205-1.022.578-1.395l5.178-5.178 2.314 2.312a2.01 2.01 0 00-.07.5 2 2 0 102-2c-.183 0-.358.031-.526.077l-2.303-2.304 3.928-3.928 9.072 9.072L14.65 25.441zM9.591 7.197a1.877 1.877 0 010-2.65c.731-.73 1.921-.73 2.633-.019l1.152 1.215-2.62 2.62-1.165-1.166zm6.508-4.178l-1.308 1.31-1.135-1.196a3.878 3.878 0 00-5.479 0 3.878 3.878 0 000 5.478l1.165 1.165-5.178 5.18a3.973 3.973 0 000 5.618l6.282 6.282a3.96 3.96 0 002.808 1.163 3.965 3.965 0 002.81-1.163L28 14.92 16.099 3.02z",
    fill: props.color
  }));
}

export default SvgIconPaintRexOutline;